import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Box, Link } from '@material-ui/core';

import Carousel from 'components/Carousel';

import Image from './Image';

const MiniImageSlide = ({ classes, list, onClick, height, href, target, promotionalTag }) => (
  <div style={{ minHeight: height }}>
    {promotionalTag &&
      <span style={{
        position: 'absolute',
        zIndex: '100',
        background: 'rgb(14 14 14 / 44%)',
        borderRadius: '3px',
        fontSize: '10px',
        fontWeight: '500',
        padding: '3px 7px 3px 7px',
        marginTop: '10px',
        marginLeft: '8px',
        border: '1px solid #525252',
        color: 'white',
      }}>
        Anúncio Pago
      </span>}
    <Carousel
      showStatus={false}
      showThumbs={false}
      showIndicators={0}
      emulateTouch
      {...(list.length > 1 && {
        renderArrowPrev: onClickHandler => (
          <div className={classes.arrowPrev}>
            <ArrowBackIosIcon onClick={onClickHandler} className={classes.arrow} />
          </div>
        ),
      })}
      {...(list.length > 1 && {
        renderArrowNext: onClickHandler => (
          <div className={classes.arrowNext}>
            <ArrowForwardIosIcon onClick={onClickHandler} className={classes.arrow} />
          </div>
        ),
      })}
    >
      {list.map((item, index) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={`${item.url}${index}`}
          onClick={onClick}
          className={classes.image}
          style={{ minHeight: height }}
        >
          {href ? (
            <Link href={href} target={target} underline="none">
              <Image alt="Imagem em miniatura" src={item} />
            </Link>
          ) : (
            <Image alt="Imagem em miniatura" src={item} />
          )}
        </Box>
      ))}
    </Carousel>
  </div>
);

MiniImageSlide.propTypes = {
  classes: PropTypes.object.isRequired,
  height: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  list: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  promotionalTag: PropTypes.bool
};

MiniImageSlide.defaultProps = {
  height: '180px',
  href: undefined,
  target: undefined,
  promotionalTag: false,
  onClick: () => { },
};

const styles = () => ({
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    minHeight: '180px',
    maxHeight: '180px',
  },
  arrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(50%,-50%)',
    width: '14px',
  },
  arrowPrev: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    left: '15px',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    backgroundColor: '#ffffffe6',
    borderRadius: '50%',
    height: '24px',
    width: '24px',
  },
  arrowNext: {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50%)',
    right: 'calc(0px + 15px)',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    backgroundColor: '#ffffffe6',
    borderRadius: '50%',
    height: '24px',
    width: '24px',
  },
});

export default withStyles(styles)(MiniImageSlide);
